class UiHeader extends HTMLElement {
  header?: HTMLElement | null;
  searchModal?: Element | null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById("shopify-section-header");

    this.handleSubmenuHovers();
  }

  handleSubmenuHovers() {
    const header = document.querySelector(".header-wrapper");

    this.querySelectorAll(".with-submenu").forEach((element: HTMLElement) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", element.parentNode.hasAttribute("open"));

      if (element.nextElementSibling.getAttribute("id")) {
        element.setAttribute("aria-controls", element.nextElementSibling.id);
      }

      element.addEventListener("mouseenter", (event) => {
        const timeout = header?.getAttribute("open") ? 0 : 150;

        setTimeout(() => {
          if (element.matches(":hover")) {
            element.setAttribute("aria-expanded", "true");
            element.parentNode.setAttribute("open", "true");
            header?.setAttribute("open", "true");
            this.preventHide = true;
          }
        }, timeout);
      });

      element.parentNode?.addEventListener("mouseleave", (event) => {
        const timeout = header?.getAttribute("open") ? 0 : 100;

        setTimeout(() => {
          if (!element.parentNode?.matches(":hover")) {
            element.setAttribute("aria-expanded", "false");
            element.parentNode?.removeAttribute("open");
            header?.removeAttribute("open");
            this.preventHide = false;
          }
        }, timeout);
      });
    });
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header?.querySelector("details-modal");
    this.searchModal?.close(false);
  }
}

customElements.define("ui-header", UiHeader);
